

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>FESTIVAL DEL CHANDE, MUSICA ANCESTRAL</h3>
                <p>
                    COOPMULMAG, fiel a su compromiso con la promoción de la identidad cultural 
                    y el fortalecimiento del tejido social, auspicia espacios de participación 
                    comunitaria. En esta ocasión, hizo presencia en el Festival del Chandé —música 
                    ancestral del municipio de San Sebastián de Buenavista, Magdalena— brindando 
                    apoyo y colaboración a la Fundación Los Raneros, grupo folclórico regional que 
                    enaltece nuestras raíces a través del arte y la tradición.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}